import ModelListCommon from "./ModelListCommon";

import ModelCollectionGame  from "./common/model/ModelCollectionGame"
import GameConnector  from "./common/connectors/GameConnector"
import Game from "./common/model/Types/Game";
import GamesSorted from "./ArraySortedGame";



export default class ModelListGame extends ModelListCommon {

    games:ModelCollectionGame
    gameConnector:GameConnector
    gamesSorted:GamesSorted
    

    constructor(userConnector:any ) {           
        super(userConnector);
        this.games = new ModelCollectionGame();
        this.gameConnector = new GameConnector(this.socket);     
        this.gamesSorted = new GamesSorted(this.games);    
                               
        this.gameConnector.cb_game_list_changed = (data) => { 
            if(!this.filled)           
                return;

            //this.log("on game list changed", JSON.stringify(data));            

            this.games.itemUpdate(data.game);
            this.onGameListChanged();             
        };        
    }

    getEventData():any {
        return this.gamesSorted;
    }

    getConnector():GameConnector {
        return this.gameConnector;
    }
            
    async doDataClear() {  
        super.doDataClear();      
        this.games.clear();
        this.onGameListChanged();
    }    

    async doDataFetch() {             
        super.doDataFetch(); 

        let result;
        this.games.clear();
        let modified = false;
        result = await this.gameConnector.doGetListSearch({ status: "active", ownership: "my" }, {page:0, pageSize:20});         
        this.games.itemUpdateArray(result.models);
        //@ts-expect-error:
        modified |= result.models.length > 0;
        
        result = await this.gameConnector.doGetListSearch({ status: "active" }, {page:0, pageSize:100}); 
        this.games.itemUpdateArray(result.models);
        //@ts-expect-error:
        modified |= result.models.length > 0;        

        if(modified)
            this.onGameListChanged();     
    }

    onGameListChanged() {                                
        this.gamesSorted.update(this.games, <string>this.playerUuid);
        this.emit(ModelListCommon.EVENT_DATA_CHANGED, this.getEventData());
    }
}
